import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { BaseResponse } from '../models/response/BaseResponse';
import { FactorialProject } from '../models/FactorialProject';

@Injectable({
  providedIn: 'root'
})
export class FactorialProjectService extends HttpService {

  index(): Observable<BaseResponse<FactorialProject[]>> {
    return this.get('factorial/projects');
  }
}
